/** Keep these presentation rules identical across the four chat clients. */
const AVATAR_COLORS = ['#365D9D', '#2B6A63', '#70539A', '#9B4D68', '#8A5B35', '#536277'];

export function chatAvatarColor(userId) {
    return userId != null && Number.isSafeInteger(userId)
        ? AVATAR_COLORS[Math.abs(userId) % AVATAR_COLORS.length]
        : AVATAR_COLORS[AVATAR_COLORS.length - 1];
}

export function chatUserInitials(name) {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    const text = parts.length > 1
        ? Array.from(parts[0])[0] + Array.from(parts[parts.length - 1])[0]
        : Array.from(parts[0]).slice(0, 2).join('');
    return Array.from(text.toUpperCase()).slice(0, 2).join('');
}

/** A fixed-width local time fits the avatar gutter without a day-period suffix. */
export function chatGroupTime(value) {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return '';
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

export function chatLastReplyLabel(value, now = new Date()) {
    if (!value) return '';
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return '';
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const day = date.toDateString() === now.toDateString() ? 'today'
        : date.toDateString() === yesterday.toDateString() ? 'yesterday'
        : date.toLocaleDateString(undefined, {day: 'numeric', month: 'short', ...(date.getFullYear() !== now.getFullYear() ? {year: 'numeric'} : {})});
    return `Last reply ${day} at ${date.toLocaleTimeString([], {hour: 'numeric', minute: '2-digit'})}`;
}
